// V1 is below this V2, it's just a refactor

class TogglePassWordVisibility {
    constructor(root) {
        this.root = root;
        this.parentRoot = this.root.parentNode;
        this.iconClasses = ['fa', 'fa-eye', 'show-password-icon', 'hidden'];
        this.icon = this.createShowPasswordButton();
        this.init();
    }

    init() {
        this.displayButtonIfNecessary = this.displayButtonIfNecessary.bind(this);
        this.toggleInput = this.toggleInput.bind(this);
        this.addListeners();
    }

    toggleInput() {
        const type = this.root.getAttribute('type');
        const switchToPasswordType = type === 'text';
        this.root.setAttribute('type', this.inputTypeValue(switchToPasswordType));
    }

    inputTypeValue(switchToPasswordType) {
        return switchToPasswordType ? 'password' : 'text';
    }

    createShowPasswordButton() {
        const icon = document.createElement('i');
        icon.classList.add(...this.iconClasses);
        this.parentRoot.appendChild(icon);
        return icon;
    }

    displayButtonIfNecessary() {
        const inputVHasValue = !!this.root.value;
        this.icon.classList.toggle(this.iconClasses[3], !inputVHasValue);
    }

    addListeners() {
        this.root.addEventListener('keyup', this.displayButtonIfNecessary);
        this.icon.addEventListener('click', this.toggleInput);
    }

    removeListeners() {
        this.root.removeEventListener('keyup', this.displayButtonIfNecessary);
        this.icon.removeEventListener('click', this.toggleInput);
    }
}

Hop.defineModule('show-password-v2', (root) => {
    const togglePasswordVisibilty = new TogglePassWordVisibility(root);

    return function destroy() {
        togglePasswordVisibilty.removeListeners();
    };
});

Hop.defineModule('show-password', (root) => {
    function toggleInput($input) {
        const type = $input.attr('type');
        const switchToPasswordType = type === 'text';
        $input.attr('type', switchToPasswordType ? 'password' : 'text');

        if (!switchToPasswordType) {
            // let's ensure that previous user entries won't show up!
            $input.attr('autocomplete', 'off');
        }
    }

    function createShowPasswordButton($container) {
        $container.append("<i class='fa fa-eye show-password-icon hidden'></i>");
        return $container.find('.show-password-icon');
    }

    function displayButtonIfNecessary($input, $showButton) {
        const inputHasText = !!$input.val();
        const buttonIsVisible = $showButton.is(':visible');

        if (inputHasText && !buttonIsVisible) {
            $showButton.removeClass('hidden');
        }

        if (!inputHasText && buttonIsVisible) {
            $showButton.addClass('hidden');
        }
    }

    const $input = $(root);
    const $container = $input.parent();
    const $showButton = createShowPasswordButton($container);

    $input.on('input change keyup onpropertychange', () => displayButtonIfNecessary($input, $showButton));
    $container.on('click', '.show-password-icon', () => toggleInput($input));

    displayButtonIfNecessary($input, $showButton);
});
